import React from 'react';
import { Query, Mutation } from '@apollo/react-components';
import { Redirect } from 'react-router-dom';
import SpinnerError from '$components/library/SpinnerError';
import { gql } from '@apollo/client';
import { notification } from 'antd';
import AuthLayout from '$components/layout/AuthLayout';
import CURRENT_USER from '$queries/currentUser';
import storage from '$lib/storage';
import { trackSignUp } from '$lib/tracking';
import routes from '@achievable-me/tundra-wizard/routes';
import AccountSetupForm from './AccountSetupForm';

const AccountSetupSearchQuery = gql`
  query AccountSetupSearch($input: AccountSetupSearchInput!) {
    accountSetupSearch(input: $input) {
      needsSetup
      user {
        uuid
        email
        activeProductSlug
      }
    }
  }
`;

const AccountSetupMutation = gql`
  mutation AccountSetup($input: AccountSetupInput!) {
    accountSetup(input: $input) {
      user {
        uuid
        email
      }
      accessToken
    }
  }
`;

const Form = (props) => {
  const { user } = props;
  return (
    <Mutation
      mutation={AccountSetupMutation}
      refetchQueries={[{ query: CURRENT_USER }]}
      update={(_cache, { data, error }) => {
        const { accountSetup } = data;
        if (!accountSetup) {
          notification.error({
            message: 'Error',
            description: error,
          });
          return;
        }

        const {
          user: { uuid, email },
          accessToken,
        } = accountSetup;
        storage.setAuth({ email, accessToken });

        trackSignUp({ userUuid: uuid, skipAffiliate: true, sourcePage: 'onboarding' });
      }}
    >
      {(accountSetup, { loading }) => (
        <AccountSetupForm accountSetup={accountSetup} loading={loading} user={user} />
      )}
    </Mutation>
  );
};

const Welcome = (props) => {
  const { match } = props;
  const { params } = match;
  const { userUuid } = params;

  if (!userUuid) {
    return <Redirect to="/" />;
  }

  return (
    <AuthLayout>
      <Query
        query={AccountSetupSearchQuery}
        variables={{ input: { userUuid } }}
        fetchPolicy="network-only"
      >
        {({ loading, error, data }) => {
          if (loading || error) {
            return <SpinnerError error={error} />;
          }

          const {
            accountSetupSearch: { needsSetup, user },
          } = data;
          if (!needsSetup) {
            return <Redirect to={routes.auth.signIn} />;
          }

          return <Form user={user} />;
        }}
      </Query>
    </AuthLayout>
  );
};

export default Welcome;
